import React, { ButtonHTMLAttributes } from 'react';

import { Container } from './styles';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Rótulo acessível — obrigatório, pois o botão não tem texto visível. */
  label: string;
  /** Tom visual: neutro (padrão) ou perigo. */
  tone?: 'neutral' | 'danger';
  children: React.ReactNode;
}

/**
 * Botão de ícone do admin. Sempre tem `aria-label` e `title`, para que a ação
 * não dependa de o usuário adivinhar o desenho.
 */
const IconButton: React.FC<IconButtonProps> = ({
  label,
  tone = 'neutral',
  children,
  ...rest
}) => (
  <Container type="button" tone={tone} aria-label={label} title={label} {...rest}>
    {children}
  </Container>
);

export default IconButton;
